import { render, staticRenderFns } from "./collectibles.vue?vue&type=template&id=cc7f07ae&"
import script from "./collectibles.vue?vue&type=script&lang=js&"
export * from "./collectibles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports